import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';

export const useAiReceptionistAccess = () => {
  const { getCustomizationFlagValue, getFeatureFlagValue } = useScopedAppFlagStore();
  const { selectedLocationIds } = useAppScopeStore();
  const hasAiReceptionistACL = selectedLocationIds.some((locationId) =>
    hasSchemaACL(locationId, Permission.AI_SETTINGS_WRITE)
  );

  const hasAiReceptionistFeatureFlag = getFeatureFlagValue('bridgeline-settings');

  const hasTlAiVoiceAccess = getCustomizationFlagValue('truelarkaivoice');
  const hasTlAiMessagingAccess = getCustomizationFlagValue('truelarkaimessaging');

  const hasAiReceptionistAccess =
    (hasTlAiVoiceAccess || hasTlAiMessagingAccess) && hasAiReceptionistACL && hasAiReceptionistFeatureFlag;

  return {
    hasTlAiVoiceAccess,
    hasTlAiMessagingAccess,
    hasAiReceptionistAccess,
  };
};
